<template>
  <fullscreen-modal
    id="ContentExportOverlay"
    @open="onOverlayOpen"
    @close="onOverlayClose"
  >
    <template slot="header">
      <step-indicator
        :steps="steps"
        :step-index="stepIndex"
      />
    </template>

    <component :is="currentStep" />
  </fullscreen-modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import PageMixin from '@/mixins/pages/Page'
import FullscreenModal from '@/components/app/FullscreenModal'
import StepIndicator from '@/components/ui/OverlayStepIndicator'
import StepFormat from '@/components/export/steps/Format'
import StepArticles from '@/components/export/steps/Articles'
import StepOutput from '@/components/export/steps/Output'

export default {
  name: 'ContentExportOverlay',

  mixins: [PageMixin],

  components: {
    StepIndicator,
    FullscreenModal,
    StepFormat,
    StepArticles,
    StepOutput
  },

  data() {
    return {
      steps: [
        'c.contentExportOverlay.stepFormat.title',
        'c.contentExportOverlay.stepArticles.title',
        'c.contentExportOverlay.stepOutput.title'
      ]
    }
  },

  computed: {
    ...mapState({
      stepIndex: state => state.contentExport.stepIndex,
    }),

    ...mapGetters({
      currentStep: 'contentExport/currentStep'
    })
  },

  methods: {
    ...mapActions({
      fetchArticles: 'contentExport/fetchArticles',
      selectAllArticles: 'contentExport/selectAllArticles',
      useSearchContent: 'contentExport/useSearchContent',
      reset: 'contentExport/reset'
    }),

    onOverlayOpen () {
      if (this.$route.params.folderId) {
        const params = {
          params: {
            folder_ids: this.$route.params.folderId
          }
        }

        this.fetchArticles(params)
          .then(() => {
            this.selectAllArticles(true)
          })
      } else {
        this.useSearchContent()
      }
    },

    onOverlayClose () {
      this.reset()
    }
  }
}
</script>

<style lang="sass">
@import "~styles/imports"

.content-export
  &__header
    text-align: center

  &__foldername
    +font-size(14, 20)
    color: $color-grey-2

  &__headline
    +font-size(48, 48)
    margin-top: rem-calc(15)

</style>



// WEBPACK FOOTER //
// src/components/contents/ContentExportOverlay.vue